import styled from 'styled-components';
import Image from '@stencil/image';

import {Row} from './../../common/Layouts/Layouts';

export const TabsRnrDiv = styled(Row)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.medium};
  padding:${props.theme.spacing.large}; ${props.theme.spacing.xlarge} 0;
  align-items: center;
  justify-content: space-between;
`,
);

export const ContentTabUl = styled.ul`
  width: 100%;
  flex-direction: row;
  display: flex;
  > li {
    display: flex;
    color: #898b91;
    padding-right: 15px;
    padding-left: 10px;
    padding-bottom: 15px;
    font-size: 16px;
    cursor: pointer;
    align-items: center;
    &.active {
      border-bottom: 2px solid #2276e3;
      font-weight: bold;
      color: black;
      font-size: 16px;
    }
  }
`;

export const TAImage = styled(Image)(
  props => `
    display: flex;
    width: 5.1rem
    height: 3rem;
    padding-right:${props.theme.spacing.small};
`,
);
